import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CountryISO } from 'ngx-intl-tel-input-gg';
import { AppointmentDetail } from 'projects/Administration/src/app/business-entities/appointmentDetail-model';
import { CustomerService } from 'projects/Administration/src/app/business-services/customer.service';
import { EditAppointmentService } from 'projects/Administration/src/app/business-services/edit-appointment.service';
import { SettingService } from 'projects/Administration/src/app/business-services/setting.service';
import { CultureLocaleService } from 'projects/Administration/src/app/services/culture-locale.service';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { ViewCustomerComponent } from '../../../../customer/view-customer/view-customer.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserRoleMenu } from 'projects/Administration/src/app/business-entities/user-role-menu.model';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import * as Enums from '../../../../../../../../Autofacets-Core/src/app/utils/enums';
import { NgInfoModalContent } from 'projects/Autofacets-Core/src/app/shared/info-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { AppointmentCommonService } from 'projects/Administration/src/app/business-services/appointment-common.service';
import { AppointmentService } from 'projects/Administration/src/app/business-services/appointment.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CustomerValidationComponent } from '../../../../widget-appointment-request/customer-validation/customer-validation.component';
import { Features } from 'projects/Widget/src/app/business-entities/step.class';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';

@Component({
  selector: 'app-work-order-customer-details',
  templateUrl: './work-order-customer-details.component.html',
  styleUrls: ['./work-order-customer-details.component.css']
})
export class WorkOrderCustomerDetailsComponent implements OnInit {

  @Input() contactDetails: AppointmentDetail;
  @Output() updatedContactDetails = new EventEmitter<AppointmentDetail>();
  @Output() refreshCustomer = new EventEmitter<AppointmentDetail>();
  isContactInfo: boolean = false;
  vehicleContractStartDate:any;
  vehicleContractEndDate:any;
  CountryISO = CountryISO;
  isInitialLoad: boolean= true;
  onlyCountries: string[] = [];
  countryDialCodes: any[]= [];
  selectedBillToCountryISO= this.cultureLocaleService.getLocale() || CountryISO.Norway;
  selectedSellCountryISO= this.cultureLocaleService.getLocale() || CountryISO.Norway;
  userRoleRightsDetails: UserRoleMenu;
  originalEmail: string;
  useAllowSellToBillTo : boolean = false;
  featureList: Features[] = [];
  constructor(
    public editAppointmentService: EditAppointmentService,
    private readonly cultureLocaleService: CultureLocaleService,
    private readonly cdref: ChangeDetectorRef,
    private readonly settingService: SettingService,
    private readonly serviceCustomer: CustomerService,
    private readonly modalService: NgbModal,
    private readonly userService: UserDataService,
    private readonly translate: TranslateService,
    public appointmentCommonService: AppointmentCommonService,
    private readonly appointmentService: AppointmentService,
    private readonly spinner: NgxSpinnerService,
    public secureStorage: SecureStorage
  ) { }

  ngOnInit(): void {
    this.onlyCountries = this.settingService.onlyCountries;
    this.countryDialCodes = this.settingService.countryDialCodes;
    if(this.contactDetails.contactInfo)
      this.isContactInfo = true;
    if( this.contactDetails.contractStartDate && this.contactDetails.contractEndDate){
      this.vehicleContractStartDate = this.contactDetails.contractStartDate ? new Date(this.contactDetails.contractStartDate + 'Z') : null;
      this.vehicleContractEndDate = this.contactDetails.contractEndDate ? new Date(this.contactDetails.contractEndDate + 'Z') : null;
    }
    this.originalEmail = this.contactDetails.email;
    this.setDialCodes();
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === Enums.ModuleNames.Customer);
    this.featureList = this.secureStorage.getKeyData('feature');
    if (this.featureList?.length > 0) {
      this.useAllowSellToBillTo = this.featureList.find(x => x.featureCode === Enums.FeatureCode.AllowBillToSellToCustomer)?.isActive ?? false;
    }
  }

  setDialCodes(){
    if(this.contactDetails.billToCustomerMobileCode != null){
      this.selectedBillToCountryISO = this.getCountryCodeByDialCode(this.contactDetails.billToCustomerMobileCode);
    }
    if(this.contactDetails.customerMobileCode != null){
      this.selectedSellCountryISO = this.getCountryCodeByDialCode(this.contactDetails.customerMobileCode);
    }
  }

  emitContactData() {
    this.contactDetails.mobileNo= this.contactDetails.mobileNo?.number ? this.contactDetails.mobileNo.number.toString().replace(/\s+/g, '') : this.contactDetails.mobileNo;
    this.contactDetails.billToMobile= this.contactDetails.billToMobile?.number ? this.contactDetails.billToMobile.number.toString().replace(/\s+/g, '') : this.contactDetails.billToMobile;
    this.updatedContactDetails.emit(this.contactDetails);
  }
  onEmailChange() {
    if ((this.contactDetails.email || '').trim() === (this.originalEmail || '').trim())
      return;
    const modalRef = this.modalService.open(NgInfoModalContent);
    modalRef.componentInstance.modelHeader = this.translate.instant("lblAlert");
    modalRef.componentInstance.modelBody = this.translate.instant("lblAppointmentCustomerEmailNotUpdate");
    modalRef.result.then(() => {
      // This is intentional
    }, () => {
      // This is intentional
    });
  }

  isDigit(event): void {
    const isDigit = Utility.isDigit(event);
    if (!isDigit) {
      event.preventDefault();
    }
  }

  telInputObject() {
    if(this.contactDetails.customerMobileCode)
    {
      let countryCode = this.getCountryCodeByDialCode(this.contactDetails.customerMobileCode.toString());
      this.selectedBillToCountryISO= countryCode?countryCode:this.cultureLocaleService.getLocale();
    }
    else
    {
      this.selectedBillToCountryISO= this.cultureLocaleService.getLocale();
    }
  }

  getCountryCodeByDialCode(dialCode: any) {
    const country = this.countryDialCodes.find(c => c.dialCode === dialCode);
    return country ? country.countryCode : null;
  }

  onCountryChange(obj) {
    if (this.isInitialLoad) {
    this.telInputObject();
    this.contactDetails.customerMobileCode = this.contactDetails.customerMobileCode || obj.dialCode;
    this.isInitialLoad = false;
    } else {
      this.contactDetails.customerMobileCode = obj.dialCode;
    }
    this.emitContactData();
  }

  telNomineeInputObject(obj) {
    if(this.contactDetails.nomineeMobileCode)
    {
      let countryCode = obj.p.filter(x => x.dialCode == this.contactDetails.nomineeMobileCode.toString())[0].iso2;
      obj.setCountry(countryCode?countryCode:this.cultureLocaleService.getLocale());
    }
    else
    {
      obj.setCountry(this.cultureLocaleService.getLocale());
    }
  }

  onNomineeCountryChange(obj) {
    this.contactDetails.nomineeMobileCode= obj.dialCode;
    this.emitContactData();
    this.cdref.detectChanges();
  }

  viewCustomer(customer:any){
    this.serviceCustomer.customerId = customer.customerId;
    this.serviceCustomer.customerNo = customer.customerNo;
    this.serviceCustomer.customerName = customer.customerName;
    this.serviceCustomer.firstName = customer.firstName;
    this.serviceCustomer.lastName = customer.lastName;
    const modalref = this.modalService.open(ViewCustomerComponent, { size: 'lg', windowClass: 'EditPopup' });
        modalref.componentInstance.isFromServiceAdvisor = false;
        modalref.componentInstance.fromVehicleScreen = false;
        modalref.componentInstance.fromVehicleCustomerDetails = false;
  }

   onChangeSellToBillToCustomer(customer:any): void {
      const modalref = this.modalService.open(CustomerValidationComponent, {
        size: 'lg',
        scrollable: true,
        windowClass: 'pop-wid1366 CustomCardPopup',
      });
      
      modalref.componentInstance.isFromEditAppointment = true;
      modalref.result.then(
        (response) => {
          if (response.success) {
            this.spinner.show();            
            let modal ={
              CustomerId: response.customer.id,
              CustomerNo: response.customer.customerNo,
              CustomerName: response.customer.customerName,
              isSellToCustomer: customer,
              appointmentId: this.appointmentCommonService.appointmentDetails.appointmentId,
              IfsWorkOrderNumber: this.appointmentCommonService.appointmentDetails.workOrderNo
            }
            this.appointmentService.updateSellToBillToCustomer(modal).then((res) => {
              if(res){
                this.spinner.hide();
                this.refreshCustomer.emit();
              }
              else{
                this.spinner.hide();
              }
            })
          }
        }
      );
    }
}
